import { put, call } from 'redux-saga/effects';

import * as actions from '@actions/auth';
import { verifyTwoFactorAuthPhoneNumber } from '@api/auth';
import { API_STATUS_SUCCESS } from '@constants/general';
import { getUser } from '@helpers/user';
import { history, vsuiteRoutes } from '@routes';
import { userGetRequestAction } from '@store/user/user.actions';

/** @deprecated Only used in /sign-up  */
export const handleVerifyTwoFactorAuthCodeRequest = function* (payload) {
  try {
    const {
      payload: { phoneNumber, countryCode, code },
    } = payload;
    const twoFactorAuthCodeResponse = yield call(
      verifyTwoFactorAuthPhoneNumber,
      countryCode,
      phoneNumber,
      code
    );

    if (twoFactorAuthCodeResponse.status === API_STATUS_SUCCESS) {
      yield put(actions.verifyTwoFactorAuthCodeSuccess(twoFactorAuthCodeResponse));
      const storedUserObject = getUser();
      if (storedUserObject) yield put(userGetRequestAction(getUser()));
      history.push(vsuiteRoutes.DASHBOARD.make());
    } else {
      yield put(actions.verifyTwoFactorAuthCodeFailure(twoFactorAuthCodeResponse));
    }
  } catch (error) {
    yield put(actions.verifyTwoFactorAuthCodeFailure(error));
  }
};
